// extracted by mini-css-extract-plugin
export default {"applePayButton":"ApplePayCheckout_applePayButton__ELR8I","content":"ApplePayCheckout_content__urkXG","loading":"ApplePayCheckout_loading__x+DVm"};